var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcHome = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.4,
    height: 18.759,
    viewBox: "0 0 20.4 18.759",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M1.407-16a1.407 1.407 0 0 1 1.407 1.407V1.352a1.407 1.407 0 0 1-2.814 0v-15.945A1.407 1.407 0 0 1 1.407-16zm5.862 6.821a1.407 1.407 0 0 1 1.407 1.407v9.124a1.407 1.407 0 1 1-2.814 0v-9.124a1.407 1.407 0 0 1 1.407-1.407zm11.724 0A1.407 1.407 0 0 1 20.4-7.772v9.124a1.407 1.407 0 0 1-2.814 0v-9.124a1.407 1.407 0 0 1 1.407-1.407zm-5.862-3.411a1.407 1.407 0 0 1 1.407 1.407V1.352a1.407 1.407 0 0 1-2.814 0v-12.534a1.407 1.407 0 0 1 1.407-1.407z",
    transform: "translate(0 16)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_home.9b388074.svg";
export { ForwardRef as ReactComponent };